import { SvgIcon, SvgIconProps } from '@mui/material';
import nagadSvg from './nagad.svg';

const NagadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <image href={nagadSvg} width='100%' height='100%' />
  </SvgIcon>
);

export default NagadIcon;
